import { useInfiniteQuery, useMutation, useQuery } from 'react-query'
import { queryClient } from '../../features/react-query-provider/ReactQueryClientProvider'
import {
  CreateNewsDto,
  getNews,
  GetNewsParams,
  getOneNews,
  UpdateNewsDto,
  useNewsAPI
} from '../api/v2/NewsAPI'
import { getNextPage, getPreviousPage } from './common'

export const useNews = (params?: GetNewsParams) => {
  return useInfiniteQuery(
    ['news'],
    ({ pageParam = params?.page || 1 }) => getNews({ ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage)
    }
  )
}

export const useOneNews = ({ id }: { id: number }) => {
  return useQuery(['news', id], () => getOneNews(id))
}

export const useCreateNews = () => {
  const { createNews } = useNewsAPI()

  return useMutation(({ dto }: { dto: CreateNewsDto }) => createNews(dto), {
    onSuccess: () => {
      queryClient.invalidateQueries(['news'])
    }
  })
}

export const useUpdateNews = () => {
  const { updateNews } = useNewsAPI()

  return useMutation(({ id, dto }: { id: number; dto: UpdateNewsDto }) => updateNews({ id, dto }), {
    onSuccess: () => {
      queryClient.invalidateQueries(['news'])
    }
  })
}

export const useDeleteNews = () => {
  const { deleteNews } = useNewsAPI()

  return useMutation(({ id }: { id: number }) => deleteNews(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(['news'])
    }
  })
}
